window.SupportPage = function SupportPage() {
  const [siteContactInfo, setSiteContactInfo] = React.useState({
    companyName: "NOVATEK Industrial Systems",
    address: "NOVATEK Engineering Complex, Technology Park, Sector 4, Pune / Bengaluru Hub, India",
    phones: ["18002587555", "18002587111"],
    emails: ["info@novatek.co.in", "it.team@novatek.co.in"]
  });

  React.useEffect(() => {
    fetchContactInfo();
    const interval = setInterval(fetchContactInfo, 5000);
    const handleSync = () => fetchContactInfo();
    window.addEventListener('storage', handleSync);
    window.addEventListener('novatek_content_updated', handleSync);
    return () => {
      clearInterval(interval);
      window.removeEventListener('storage', handleSync);
      window.removeEventListener('novatek_content_updated', handleSync);
    };
  }, []);

  const fetchContactInfo = async () => {
    try {
      const res = await window.apiClient.get('content.php');
      if (res.success && res.data && res.data.contact_info) {
        setSiteContactInfo(res.data.contact_info);
      }
    } catch (e) {
      console.warn('SupportPage contact info fetch warning:', e);
    }
  };

  return (
    <div className="py-12 bg-slate-50 min-h-[60vh] flex items-center justify-center">
      <div className="max-w-4xl w-full px-6 space-y-8">

        {/* Main Heading */}
        <div className="text-center space-y-1">
          <span className="font-mono text-xs sm:text-sm font-extrabold tracking-widest uppercase block text-secondary">
            Need Support
          </span>
          <h2 className="font-sans text-2xl sm:text-3xl font-extrabold text-slate-800 tracking-wide uppercase">
            You Can Reach Us At
          </h2>
        </div>

        {/* Card Container */}
        <div className="bg-white rounded-2xl border border-slate-200/80 shadow-lg p-6 sm:p-10 relative overflow-hidden">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-stretch relative">

            {/* Left Column (Contact Number) */}
            <div className="space-y-6 md:pr-4">
              <span className="block font-sans text-xs font-bold text-slate-900 tracking-wider uppercase">
                Contact Number:
              </span>

              <div className="space-y-5">
                {/* Mobile Number Row 1 */}
                <div className="flex gap-4 items-start">
                  <div className="h-10 w-10 rounded-full border border-slate-300 hover:border-blue-900 flex items-center justify-center text-slate-500 hover:text-blue-900 transition-colors shrink-0">
                    <span className="material-symbols-outlined text-[20px] font-light">call</span>
                  </div>
                  <div className="space-y-0.5">
                    <span className="block font-sans text-xs text-slate-500 font-medium">
                      Primary Mobile Number
                    </span>
                    <a
                      href={`tel:${siteContactInfo.phones[0] || '18002587555'}`}
                      className="block font-sans text-lg sm:text-xl font-bold text-blue-900 hover:underline"
                    >
                      {siteContactInfo.phones[0] || '18002587555'}
                    </a>
                  </div>
                </div>

                {/* Mobile Number Row 2 */}
                {siteContactInfo.phones[1] && (
                  <div className="flex gap-4 items-start">
                    <div className="h-10 w-10 rounded-full border border-slate-300 hover:border-blue-900 flex items-center justify-center text-slate-500 hover:text-blue-900 transition-colors shrink-0">
                      <span className="material-symbols-outlined text-[20px] font-light">call</span>
                    </div>
                    <div className="space-y-0.5">
                      <span className="block font-sans text-xs text-slate-500 font-medium">
                        Secondary Mobile Number
                      </span>
                      <a
                        href={`tel:${siteContactInfo.phones[1]}`}
                        className="block font-sans text-lg sm:text-xl font-bold text-blue-900 hover:underline"
                      >
                        {siteContactInfo.phones[1]}
                      </a>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Vertical Center Divider on Desktop */}
            <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-px bg-slate-200 -translate-x-1/2"></div>

            {/* Right Column (Email Address) */}
            <div className="space-y-6 md:pl-4">
              <span className="block font-sans text-xs font-bold text-slate-900 tracking-wider uppercase">
                Email Address:
              </span>

              <div className="space-y-5">
                {/* Sales & Service Email Row */}
                <div className="flex gap-4 items-start">
                  <div className="h-10 w-10 rounded-full border border-slate-300 hover:border-blue-900 flex items-center justify-center text-slate-500 hover:text-blue-900 transition-colors shrink-0">
                    <span className="material-symbols-outlined text-[18px] font-light">alternate_email</span>
                  </div>
                  <div className="space-y-0.5">
                    <span className="block font-sans text-xs text-slate-500 font-medium">
                      Sales, Service related Queries
                    </span>
                    <a
                      href={`mailto:${siteContactInfo.emails[0] || 'info@novatek.co.in'}`}
                      className="block font-sans text-sm sm:text-base font-bold text-blue-900 hover:underline break-all"
                    >
                      {siteContactInfo.emails[0] || 'info@novatek.co.in'}
                    </a>
                  </div>
                </div>

                {/* IT Queries Email Row */}
                <div className="flex gap-4 items-start">
                  <div className="h-10 w-10 rounded-full border border-slate-300 hover:border-blue-900 flex items-center justify-center text-slate-500 hover:text-blue-900 transition-colors shrink-0">
                    <span className="material-symbols-outlined text-[18px] font-light">alternate_email</span>
                  </div>
                  <div className="space-y-0.5">
                    <span className="block font-sans text-xs text-slate-500 font-medium">
                      IT Support, Website related Queries
                    </span>
                    <a
                      href={`mailto:${siteContactInfo.emails[1] || 'it.team@novatek.co.in'}`}
                      className="block font-sans text-sm sm:text-base font-bold text-blue-900 hover:underline break-all"
                    >
                      {siteContactInfo.emails[1] || 'it.team@novatek.co.in'}
                    </a>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  );
};
